import React from 'react';

const UserAvatar = ({ 
  user, 
  size = 'md', 
  className = '',
  showOnlineStatus = false 
}) => {
  // Size configurations
  const sizeClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-2xl',
    '2xl': 'w-20 h-20 text-3xl'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;
  
  // Get user's initials
  const getInitials = (name) => {
    if (!name) return 'U';
    const nameParts = name.trim().split(' ');
    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }
    return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
  };

  // Check if user has an avatar (prioritize avatar_url over avatar)
  const avatarUrl = user?.avatar_url || user?.avatar;
  const hasAvatar = avatarUrl && avatarUrl.trim() !== '';

  return (
    <div className={`relative ${className}`}>
      <div className={`${sizeClass} rounded-full flex items-center justify-center text-white font-bold overflow-hidden`}>
        {hasAvatar ? (
          <img
            src={avatarUrl}
            alt={`${user.name || 'User'}'s avatar`}
            className="w-full h-full object-cover"
            onError={(e) => {
              // Fallback to initials if image fails to load
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div 
          className={`w-full h-full flex items-center justify-center ${
            hasAvatar ? 'hidden bg-gradient-to-r from-blue-500 to-indigo-600' : 'bg-gradient-to-r from-blue-500 to-indigo-600'
          }`}
          style={{ display: hasAvatar ? 'none' : 'flex' }}
        >
          {getInitials(user?.name)}
        </div>
      </div>
      
      {/* Online status indicator */}
      {showOnlineStatus && (
        <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white ${
          user?.status === 'active' ? 'bg-green-500' : 'bg-gray-400'
        }`} />
      )}
    </div>
  );
};

export default UserAvatar;
